import React  from "react";
import {Col, Form, FormGroup, Input, Label, Row} from "reactstrap";

import {
    FL_IMAGE,
    FL_LONG_DESCRIPTION,
    FL_SHORT_DESCRIPTION,
    FL_TITLE
} from "../../../components/i18n/formLabels";
import {
    PH_IMAGE,
    PH_LONG_DESCRIPTION,
    PH_SHORT_DESCRIPTION,
    PH_TITLE
} from "../../../components/i18n/placeHolders";

import { LangController } from "../../../components/tabs/langController";


const SuiteControllerLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id:lang?.id, name:lang?.name, showOrder: lang?.showOrder },
            title: '',
            image: '',
            longDescription: '',
            shortDescription: '',
        }) )
        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <>
                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Label>{ FL_TITLE }</Label>
                            <Input
                                type="text"
                                name="title"
                                placeholder={ PH_TITLE }
                                value={ child.title || '' }
                                onChange={e => onInputChange(e, child.lang)}
                                disabled={ disableInputs }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="6">
                        <FormGroup>
                            <Label>{ FL_IMAGE }</Label>
                            <Input
                                type="text"
                                name="image"
                                placeholder={ PH_IMAGE }
                                value={ child.image || '' }
                                onChange={e => onInputChange(e, child.lang)}
                                disabled={ disableInputs }
                            />
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <Label>{ FL_SHORT_DESCRIPTION }</Label>
                            <Input
                                type="textarea"
                                rows="5"
                                name="shortDescription2"
                                placeholder={ PH_SHORT_DESCRIPTION }
                                value= { child.shortDescription2 || '' }
                                onChange={e => onInputChange(e, child.lang)}
                                disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="12">
                        <FormGroup>
                            <Label>{ FL_LONG_DESCRIPTION }</Label>
                            <Input
                                type="textarea"
                                rows="10"
                                name="longDescription"
                                placeholder={ PH_LONG_DESCRIPTION }
                                value= { child.longDescription || '' }
                                onChange={e => onInputChange(e, child.lang)}
                                disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </>

    return <LangController
        langs={props?.langs}
        setLangs={props?.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props?.translatableLangs}
    />
}

export default SuiteControllerLangs